import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const http = axios.create({ baseURL: API, timeout: 20000 });

let configPromise;
export const getConfig = () => {
  if (!configPromise) {
    configPromise = http
      .get("/config")
      .then((r) => r.data || {})
      .catch(() => ({}));
  }
  return configPromise;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -16, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const pageUrl = () => `${window.location.origin}/`;

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  }
};
